/* corex-textil-editor-flat.js · Prenda extendida en plano para el EDITOR del personalizador (dibujo vectorial).
   La foto TopTex es un maniquí 3D, más estrecho que la prenda real; en el editor se diseña sobre la prenda plana a
   las medidas reales de la talla de referencia (escala uniforme en los dos ejes) y la foto queda para la vista previa.
   PLANTILLAS por tipo de prenda (corex.prenda; ver corex-textil-editor-prendas.js): cada una recibe las medidas de la
   talla y da los marcos (bodyFrame/sleeveFrame), el dibujo (draw), la zona útil (useful) y las cotas de la prenda
   (measures). Hechas: "camiseta-mc" y sus variantes (tanda 1): "oversize", "tirantes", "crop-top", "camiseta-ml" y
   "raglan"; sudaderas (tanda 2): "sudadera" (cuello redondo), "sudadera-capucha", "sudadera-cremallera",
   "sudadera-cremallera-capucha" y "sudadera-cuarto-cremallera". Todas salen de make(key, estilo): las proporciones de cada una están en su estilo (STYLES), en fracción del
   ½ contorno de pecho P; el largo y la manga son los de la guía de la talla.
   Coordenadas como en el resto del editor: u = cm desde el eje (+ derecha de la imagen), v = cm hacia abajo desde el
   cuello de la vista (delantero o trasero); en la manga, v = 0 en el hombro (raglán: en el cuello).
   Medidas de corex.medidas: pecho (½ contorno = ancho en plano), largo (del punto alto del hombro al bajo), manga
   (de la costura del hombro al bajo; raglán: desde el cuello; tirantes: no hay) y, si la guía los da, hombros (ancho
   de costura a costura) u hombro (largo de la costura del hombro). */
(function (global) {
  'use strict';

  /* Proporciones estándar de camiseta, en fracción del ½ contorno de pecho P (afinar aquí). */
  var SHAPE = {
    NECK_W: 0.34,           /* ancho del cuello entre los puntos altos del hombro = 0,34·P */
    FRONT_DROP: 0.145,      /* caída del cuello delantero bajo el punto alto del hombro = 0,145·P (≈ 8 cm en L, la foto calibrada) */
    BACK_DROP_CM: 1.5,      /* caída del cuello trasero (cm) */
    SHOULDER_W: 0.85,       /* de hombro a hombro = 0,85·P */
    SHOULDER_SLOPE: 0.07,   /* caída del hombro (punto alto → costura del hombro) = 0,07·P */
    ARMHOLE: 0.44,          /* profundidad de sisa desde el punto alto del hombro = 0,44·P */
    SLEEVE_ANGLE_DEG: 20,   /* borde superior de la manga, grados bajo la horizontal */
    SLEEVE_HEM: 0.33,       /* ancho del bajo de la manga en plano = 0,33·P */
    SLEEVE_CAP: 0.2,        /* alto de la copa (vista de la manga) = 0,2 · ancho de la sisa */
    RIB_CM: 1.8,            /* canalé del cuello */
    HEM_STITCH_CM: 2.5,     /* pespunte del bajo */
    SLEEVE_STITCH_CM: 2     /* pespunte del bajo de la manga */
  };
  /* Variantes de la tanda 1: lo que cambia respecto a SHAPE. sleeves: 'montada' (costura en el hombro), 'raglan'
     (costura diagonal del cuello a la sisa) o 'sin' (tirantes). */
  var STYLES = {
    'camiseta-mc': { sleeves: 'montada' },
    /* Hombros caídos: la costura del hombro baja por el brazo (de costura a costura ≈ el ancho de pecho o más), cuerpo
       recto y ancho (el de la guía), sisa más baja, manga más ancha que cae más. */
    oversize: { sleeves: 'montada', NECK_W: 0.36, FRONT_DROP: 0.13, SHOULDER_W: 1.06, SHOULDER_SLOPE: 0.05, ARMHOLE: 0.5,
      SLEEVE_ANGLE_DEG: 32, SLEEVE_HEM: 0.4, SLEEVE_CAP: 0.08 },
    /* Sin mangas: escote más ancho y bajo (también detrás), tirante estrecho y sisa amplia hasta el costado. */
    tirantes: { sleeves: 'sin', NECK_W: 0.46, FRONT_DROP: 0.26, BACK_DROP: 0.1, STRAP_W: 0.1, SHOULDER_SLOPE: 0.03, ARMHOLE: 0.54,
      ARMHOLE_BIND_CM: 1.2 },
    /* Cuerpo corto: el largo es el de su guía; las proporciones de arriba, las de la camiseta. Sin mangas (crop de
       tirantes): como los tirantes, con el tirante algo más ancho. */
    'crop-top': { sleeves: 'montada', SLEEVELESS: { sleeves: 'sin', NECK_W: 0.42, FRONT_DROP: 0.2, BACK_DROP: 0.06, STRAP_W: 0.14,
      SHOULDER_SLOPE: 0.04, ARMHOLE: 0.5, ARMHOLE_BIND_CM: 1.2 } },
    /* Manga larga: la manga se tiende más caída (si no, no cabe) y se estrecha hasta el puño, que lleva canalé. */
    'camiseta-ml': { sleeves: 'montada', SLEEVE_ANGLE_DEG: 62, SLEEVE_HEM: 0.19, SLEEVE_CAP: 0.18, SLEEVE_STITCH_CM: 6, DEFAULT_SLEEVE: 60 },
    /* Raglán: sin costura en el hombro; la manga sube hasta el cuello y la costura va en diagonal del escote a la sisa
       (limita la zona útil delantera). La manga de la guía se mide desde el cuello. RAGLAN_NECK: punto del escote donde
       arranca la costura, en fracción del medio ancho del cuello. */
    raglan: { sleeves: 'raglan', SLEEVE_ANGLE_DEG: 24, RAGLAN_NECK: 0.72, SLEEVE_NECK_W: 0.16, RAGLAN_ARM_W: 0.44,
      DEFAULT_SLEEVE: 26 }
  };
  /* Sudaderas (tanda 2): manga larga montada con puño de canalé y cintura de canalé, más ancha y algo más caída que la
     camiseta de manga larga. Lo que las distingue (en cm salvo que diga ·P):
     CUFF_CM: alto del canalé del puño (la impresión de manga nunca lo pisa; su distancia se mide desde el puño).
     WAIST_CM: alto del canalé de la cintura (la zona útil termina por encima); WAIST_IN: lo que se recoge a cada lado
     el canalé respecto al ½ pecho (·P).
     HOOD: capucha { UP: lo que sube sobre el punto alto del hombro (·P), W: ancho en plano (·P), BACK: hasta dónde cae
     por la espalda bajo el cuello trasero (·P) }. La zona útil de detrás empieza en el cuello, como en la camiseta: la
     capucha bajada tapa la parte de arriba del diseño (el editor la dibuja encima, semitransparente, y avisa de cuánto
     tapa; la vista previa recorta el diseño por su silueta).
     POCKET: bolsillo canguro { H: alto sobre el canalé de la cintura (·P), TOP_W/BOT_W: anchos arriba/abajo (·P) };
     'partido' en las de cremallera (dos bolsillos, uno a cada lado). La zona útil delantera termina por encima.
     ZIP: 'completa' (parte el delantero: Pecho izq. y Pecho dcha., nunca sobre la cremallera ni a menos de ZIP_CLEAR_CM)
     o 'cuarto' (desde el cuello ZIP_LEN·P; la zona útil empieza por debajo). COLLAR_CM: cuello alto (cremallera sin
     capucha). */
  var SUDADERA = { sleeves: 'montada', NECK_W: 0.36, FRONT_DROP: 0.15, BACK_DROP_CM: 2, SHOULDER_W: 0.88, SHOULDER_SLOPE: 0.06,
    ARMHOLE: 0.47, SLEEVE_ANGLE_DEG: 64, SLEEVE_HEM: 0.2, SLEEVE_CAP: 0.18, SLEEVE_STITCH_CM: 7, DEFAULT_SLEEVE: 64,
    CUFF_CM: 7, WAIST_CM: 6.5, WAIST_IN: 0.04, RIB_CM: 2.4, ZIP_W_CM: 1.2, ZIP_CLEAR_CM: 1.5 };
  /* BACK: 0,23·P ≈ 12,5 cm en la talla M, la mediana de lo que baja la capucha en las fotos de espalda de TopTex
     (9-15 cm bajo el cuello); con 15 cm (lo habitual detrás), el diseño queda justo debajo. */
  var HOOD = { UP: 0.52, W: 0.62, BACK: 0.23 };
  /* Borde inferior de la capucha caída: de la punta (centro, bot) sube hasta HOOD_SIDE_U·hw del eje, donde está
     HOOD_RISE·hw más arriba, con forma t^HOOD_POW (t = |u| / (HOOD_SIDE_U·hw)). La misma curva con la que el importador
     la busca en la foto de espalda (lib/calibracion-sudadera.js, cal.capucha). */
  var HOOD_SIDE_U = 0.72, HOOD_RISE = 0.58, HOOD_POW = 1.7, HOOD_STEPS = 20;
  var POCKET = { H: 0.34, TOP_W: 0.6, BOT_W: 0.8 };
  Object.assign(STYLES, {
    sudadera: Object.assign({}, SUDADERA),
    'sudadera-capucha': Object.assign({}, SUDADERA, { FRONT_DROP: 0.2, HOOD: HOOD, POCKET: POCKET }),
    'sudadera-cremallera': Object.assign({}, SUDADERA, { FRONT_DROP: 0.06, ZIP: 'completa', COLLAR_CM: 5, POCKET: Object.assign({}, POCKET, { split: true }) }),
    'sudadera-cremallera-capucha': Object.assign({}, SUDADERA, { FRONT_DROP: 0.2, ZIP: 'completa', HOOD: HOOD, POCKET: Object.assign({}, POCKET, { split: true }) }),
    'sudadera-cuarto-cremallera': Object.assign({}, SUDADERA, { FRONT_DROP: 0.08, ZIP: 'cuarto', ZIP_LEN: 0.3, COLLAR_CM: 5.5 })
  });
  /* Tanda 3 · manga murciélago o cortada en una pieza con el cuerpo (10339, 10239 «extended shoulder», TL527, 12539):
     sin costura en el hombro ni en la sisa. La línea del hombro sigue por la manga (SLEEVE_ANGLE_DEG ≈ la pendiente del
     hombro: 0,06·P de caída en 0,28·P de hombro ≈ 12°) y la axila es una curva amplia (UNDERARM: lo que se abre hacia
     el bajo de la manga, en fracción de la distancia de la sisa al bajo) que baja hasta el costado a ARMHOLE·P, más
     honda que en la camiseta. No tiene zonas de manga: la manga es parte del cuerpo; si la guía no da la manga, se
     dibuja DEFAULT_SLEEVE desde el hombro de la plantilla. */
  STYLES.murcielago = { sleeves: 'kimono', SHOULDER_W: 0.9, SHOULDER_SLOPE: 0.06, ARMHOLE: 0.6, SLEEVE_ANGLE_DEG: 12, SLEEVE_HEM: 0.36,
    SLEEVE_CAP: 0, UNDERARM: 0.55, DEFAULT_SLEEVE: 12 };
  function pick(src, keys) { var o = {}; keys.forEach(function (k) { o[k] = src[k]; }); return o; }
  /* Tanda 3 · formas que se combinan con una plantilla (corex.prenda = "base+forma+forma", p. ej.
     "sudadera-capucha+hombros-caidos"): cada una toma los parámetros de la plantilla que ya tiene esa forma, así una
     sudadera oversize con capucha es la sudadera con capucha (capucha, bolsillo, canalés) con los hombros de la camiseta
     oversize. Se aplican en este orden. */
  var FORMAS = {
    /* hombros caídos (oversize): la costura del hombro baja por el brazo, sisa más baja y copa casi plana (camiseta
       oversize). El ancho del cuerpo y la manga son los de la guía (la manga, desde la costura caída: más corta). */
    'hombros-caidos': pick(STYLES.oversize, ['NECK_W', 'SHOULDER_W', 'SHOULDER_SLOPE', 'ARMHOLE', 'SLEEVE_CAP']),
    /* raglán: la costura diagonal del escote a la sisa de la camiseta raglán; la manga de la guía se mide desde el
       cuello (sudadera: unos 10 cm más que desde el hombro, de ahí DEFAULT_SLEEVE). La manga sale del cuello: a los 64°
       de la sudadera quedaría encima del cuerpo; tendida a 45° la sisa queda libre, como en plano. */
    raglan: Object.assign(pick(STYLES.raglan, ['sleeves', 'RAGLAN_NECK', 'SLEEVE_NECK_W', 'RAGLAN_ARM_W']), { SLEEVE_ANGLE_DEG: 45, DEFAULT_SLEEVE: 74 }),
    /* manga corta: la de la camiseta (con hombros caídos, la de la oversize), sin puño de canalé */
    'manga-corta': { SLEEVE_ANGLE_DEG: SHAPE.SLEEVE_ANGLE_DEG, SLEEVE_HEM: SHAPE.SLEEVE_HEM, SLEEVE_CAP: SHAPE.SLEEVE_CAP,
      SLEEVE_STITCH_CM: SHAPE.SLEEVE_STITCH_CM, CUFF_CM: 0, DEFAULT_SLEEVE: 17 },
    /* sin mangas: la sisa con ribete de los tirantes, pero el tirante llega hasta el hombro de la prenda (de una sudadera
       se cortan las mangas por la costura): STRAP_W = (SHOULDER_W − NECK_W) / 2; con hombros caídos, el hombro sobresale
       del cuerpo como una manga muy corta (NS446). */
    'sin-mangas': Object.assign(pick(STYLES.tirantes, ['sleeves', 'ARMHOLE', 'ARMHOLE_BIND_CM']), { SHOULDER_SLOPE: 0.05 }),
    /* crop: el largo es el de su guía; no cambia la forma (solo el nombre) */
    crop: {},
    /* sin bolsillo delantero (bolsillos laterales o ninguno): la zona útil de delante llega hasta el canalé */
    'sin-bolsillo': { POCKET: null }
  };
  var FORMAS_ORDEN = Object.keys(FORMAS);
  /* Estilo de "base+forma+…" (null si la base o alguna forma no existen). */
  function compose(key) {
    var parts = String(key).split('+'), base = STYLES[parts[0]], formas = parts.slice(1);
    if (!base || formas.some(function (f) { return !FORMAS[f]; })) return null;
    var st = Object.assign({}, SHAPE, base);
    FORMAS_ORDEN.filter(function (f) { return formas.indexOf(f) >= 0; }).forEach(function (f) {
      Object.assign(st, FORMAS[f]);
      if (f === 'manga-corta' && formas.indexOf('hombros-caidos') >= 0) Object.assign(st, pick(STYLES.oversize, ['SLEEVE_ANGLE_DEG', 'SLEEVE_HEM']));
      if (f === 'sin-mangas') st.STRAP_W = (st.SHOULDER_W - st.NECK_W) / 2;
    });
    return st;
  }
  var RIB_MARGIN_CM = 1.5;  /* aire entre la zona útil y el canalé de la cintura, el bolsillo, la capucha o la cremallera */
  var K = 10;               /* unidades del lienzo por cm */
  var MARGIN_CM = 3;        /* aire alrededor de la prenda más grande */
  var TOP_ROOM_CM = 5;      /* aire sobre el cuello (cotas y etiquetas) */
  var DARK_LUMA = 90;       /* por debajo, la tela se considera oscura (costuras claras) */
  var CHEST_BELOW_ARMPIT_CM = 1.5; /* el pecho se mide de costado a costado 1,5 cm bajo la sisa (guía de medidas) */
  var DIM_GAP_CM = 2.5;     /* separación de las cotas de la prenda respecto al contorno */
  var LABEL_ROOM_CM = 9;    /* sitio para la cota del pecho en las prendas sin mangas */
  var CURVE_STEPS = 14;     /* tramos con los que se aproxima la curva de la sisa sin mangas */
  var SHOULDERS_RANGE = [0.6, 1.25]; /* hombros de la guía aceptados, en fracción de P (fuera, se usa el estilo) */

  function add(a, b, f) { return { u: a.u + b.u * f, v: a.v + b.v * f }; }
  function mirror(p) { return { u: -p.u, v: p.v }; }
  function bez(a, c1, c2, b, t) {
    var m = 1 - t;
    return { u: m * m * m * a.u + 3 * m * m * t * c1.u + 3 * m * t * t * c2.u + t * t * t * b.u,
      v: m * m * m * a.v + 3 * m * m * t * c1.v + 3 * m * t * t * c2.v + t * t * t * b.v };
  }
  /* Medio ancho a la altura v de una polilínea que baja (puntos ordenados por v). */
  function uAt(pts, v) {
    if (v <= pts[0].v) return pts[0].u;
    for (var i = 1; i < pts.length; i++) {
      if (v <= pts[i].v) { var a = pts[i - 1], b = pts[i], f = (v - a.v) / ((b.v - a.v) || 1); return a.u + (b.u - a.u) * f; }
    }
    return pts[pts.length - 1].u;
  }

  function make(key, st) {
    function drop(P, kind) {
      if (kind === 'back') return st.BACK_DROP != null ? st.BACK_DROP * P : st.BACK_DROP_CM;
      return st.FRONT_DROP * P;
    }
    function sleeveLen(med) { return med.manga || st.DEFAULT_SLEEVE || 17; }
    /* Costura del hombro: la de la guía si la da (hombros = ancho total; hombro = largo de la costura), si no, la del
       estilo. */
    function shoulderU(med, hpsU) {
      var P = med.pecho;
      if (st.sleeves === 'kimono') return st.SHOULDER_W * P / 2; /* sin costura: el «hombro» de la guía incluye la manga */
      if (med.hombros > 0 && med.hombros / P >= SHOULDERS_RANGE[0] && med.hombros / P <= SHOULDERS_RANGE[1]) return med.hombros / 2;
      if (med.hombro > 0 && (hpsU + med.hombro) * 2 / P >= SHOULDERS_RANGE[0] && (hpsU + med.hombro) * 2 / P <= SHOULDERS_RANGE[1]) return hpsU + med.hombro;
      return st.SHOULDER_W * P / 2;
    }
    /* Puntos de la mitad derecha (cm): punto alto del hombro (hps), costura del hombro (sp), sisa (ap), bajo de la
       manga arriba y abajo (sht, shb) y bajo del cuerpo. Sin mangas: so (borde exterior del tirante) y la curva de la
       sisa (arm). Raglán: rn (arranque de la costura en el escote). */
    function shape(med, kind) {
      var P = med.pecho, d = drop(P, kind), a = st.SLEEVE_ANGLE_DEG * Math.PI / 180;
      var dir = { u: Math.cos(a), v: Math.sin(a) }, nrm = { u: -Math.sin(a), v: Math.cos(a) };
      var hps = { u: st.NECK_W * P / 2, v: -d }, ap = { u: P / 2, v: -d + st.ARMHOLE * P };
      var s = { drop: d, half: P / 2, hemV: med.largo - d, dir: dir, hps: hps, ap: ap };
      if (st.sleeves === 'sin') {
        var so = { u: hps.u + st.STRAP_W * P, v: -d + st.SHOULDER_SLOPE * P };
        var c1 = { u: so.u, v: so.v + 0.45 * (ap.v - so.v) }, c2 = { u: so.u + 0.12 * (ap.u - so.u), v: ap.v };
        var arm = [];
        for (var i = 0; i <= CURVE_STEPS; i++) arm.push(bez(so, c1, c2, ap, i / CURVE_STEPS));
        return Object.assign(s, { so: so, arm: arm, sp: so });
      }
      if (st.sleeves === 'raglan') {
        var nh = hps.u, ru = st.RAGLAN_NECK * nh;
        var rn = { u: ru, v: -d * Math.sqrt(1 - st.RAGLAN_NECK * st.RAGLAN_NECK) };
        var rt = add(hps, dir, sleeveLen(med));
        return Object.assign(s, { rn: rn, sp: rn, sht: rt, shb: add(rt, nrm, st.SLEEVE_HEM * P) });
      }
      var sp = { u: shoulderU(med, hps.u), v: -d + st.SHOULDER_SLOPE * P };
      var sht = add(sp, dir, sleeveLen(med)), shb = add(sht, nrm, st.SLEEVE_HEM * P);
      Object.assign(s, { sp: sp, sht: sht, shb: shb });
      /* manga murciélago: axila en curva del bajo de la manga al costado */
      if (st.sleeves === 'kimono') s.arm = curvePts(shb, { u: shb.u + (ap.u - shb.u) * st.UNDERARM, v: shb.v }, { u: ap.u, v: shb.v + (ap.v - shb.v) * 0.5 }, ap);
      return s;
    }
    /* Largo del cuello de la vista al bajo (cm) y ancho del bajo de la manga en plano (cm). */
    function hemV(med, kind) { return med.largo - drop(med.pecho, kind); }
    function sleeveHemW(med) { return st.SLEEVE_HEM * med.pecho; }
    function sleeveTopW(med) {
      if (st.sleeves === 'raglan') return st.RAGLAN_ARM_W * med.pecho; /* raglán: ancho de la manga a la altura de la sisa */
      var s = shape(med, 'front'); return Math.hypot(s.ap.u - s.sp.u, s.ap.v - s.sp.v);
    }
    /* Raglán: de la costura del escote a la sisa, a lo largo de la manga (cm). */
    function raglanSeam(med) { var s = shape(med, 'front'); return Math.hypot(s.ap.u - s.rn.u, s.ap.v - s.rn.v); }
    function hasSleeves() { return st.sleeves !== 'sin' && st.sleeves !== 'kimono'; }
    /* Lo que sobresale por encima del punto alto del hombro (capucha o cuello alto), cm. */
    function topExtra(s) { return st.HOOD ? st.HOOD.UP * s.half * 2 : st.COLLAR_CM ? st.COLLAR_CM : 0; }
    function extentU(s) { return Math.max(s.half, s.sht ? Math.max(s.sht.u, s.shb.u) : 0, s.sp ? s.sp.u : 0); }

    function planar(frame) {
      var k = frame.pxPerCm;
      return Object.assign(frame, {
        flat: true, maxU: 200,
        fwd: function (u, v) { return { x: frame.cx + u * k, y: frame.neckY + v * k }; },
        inv: function (x, y) { return { u: (x - frame.cx) / k, v: (y - frame.neckY) / k }; }
      });
    }
    /* Marco de delante/detrás. allMeds: medidas de todas las tallas del producto; el encuadre es el de la mayor, así la
       silueta cambia de tamaño con la talla y los diseños mantienen sus cm. */
    function bodyFrame(med, kind, allMeds) {
      var shapes = allMeds.map(function (m) { return shape(m, kind); });
      /* sin mangas, la etiqueta del pecho (fuera del costado) necesita sitio a la derecha */
      var xMax = Math.max.apply(null, shapes.map(extentU)) + MARGIN_CM + (st.sleeves === 'sin' ? LABEL_ROOM_CM : 0);
      var yTop = Math.max.apply(null, shapes.map(function (s) { return s.drop + topExtra(s); })) + TOP_ROOM_CM;
      var yBot = Math.max.apply(null, shapes.map(function (s) { return Math.max(s.hemV, s.shb ? s.shb.v : 0); })) + MARGIN_CM;
      return planar({
        tpl: T, kind: kind, med: med, shape: shape(med, kind), pxPerCm: K, cx: xMax * K, neckY: yTop * K, hemV: hemV(med, kind),
        view: { x: 0, y: 0, w: 2 * xMax * K, h: (yTop + yBot) * K }
      });
    }
    /* Marco de la manga extendida (eje vertical, hombro arriba; raglán: cuello arriba). */
    function sleeveFrame(med, allMeds) {
      var wMax = Math.max.apply(null, allMeds.map(sleeveTopW)), lMax = Math.max.apply(null, allMeds.map(sleeveLen));
      var L = sleeveLen(med), wTop = sleeveTopW(med), f = {
        tpl: T, kind: 'sleeve', med: med, L: L, wTop: wTop, wHem: sleeveHemW(med), cap: st.SLEEVE_CAP * wTop,
        pxPerCm: K, cx: (wMax / 2 + MARGIN_CM + 2) * K, neckY: TOP_ROOM_CM * K, hemV: L,
        view: { x: 0, y: 0, w: (wMax + 2 * (MARGIN_CM + 2)) * K, h: (lMax + TOP_ROOM_CM + MARGIN_CM + 1) * K }
      };
      if (st.sleeves === 'raglan') Object.assign(f, { raglan: true, wNeck: st.SLEEVE_NECK_W * med.pecho, vArm: Math.min(raglanSeam(med), L - 3) });
      return planar(f);
    }

    /* ---------- dibujo ---------- */
    function path(frame, pts) {
      var p = new Path2D();
      pts.forEach(function (q, i) { var x = frame.fwd(q.u, q.v); if (i) p.lineTo(x.x, x.y); else p.moveTo(x.x, x.y); });
      return p;
    }
    /* Curva del cuello de un punto alto del hombro al otro pasando por (0, 0) (cuello de la vista) o por depth. */
    function neckCurve(p, frame, nh, top, depth) {
      var f = function (u, v) { return frame.fwd(u, v); }, a = f(-nh, top), c1 = f(-nh, top + (depth - top) * 0.65), c2 = f(-nh * 0.55, depth), m = f(0, depth);
      var c3 = f(nh * 0.55, depth), c4 = f(nh, top + (depth - top) * 0.65), b = f(nh, top);
      p.moveTo(a.x, a.y);
      p.bezierCurveTo(c1.x, c1.y, c2.x, c2.y, m.x, m.y);
      p.bezierCurveTo(c3.x, c3.y, c4.x, c4.y, b.x, b.y);
      return p;
    }
    /* Contorno de la mitad derecha, del punto alto del hombro al bajo. */
    function rightSide(s) {
      var top = st.sleeves === 'sin' ? [s.hps].concat(s.arm) : st.sleeves === 'raglan' ? [s.hps, s.sht, s.shb, s.ap]
        : st.sleeves === 'kimono' ? [s.hps, s.sp, s.sht].concat(s.arm) : [s.hps, s.sp, s.sht, s.shb, s.ap];
      /* sudaderas: el canalé de la cintura recoge el bajo */
      if (st.WAIST_CM) return top.concat([{ u: s.half, v: s.hemV - st.WAIST_CM }, { u: s.half - st.WAIST_IN * s.half * 2, v: s.hemV }]);
      return top.concat([{ u: s.half, v: s.hemV }]);
    }
    function bodyPath(frame) {
      var s = frame.shape, right = rightSide(s);
      var left = right.slice().reverse().map(mirror);
      var p = path(frame, right.concat(left));
      /* cuello: del hombro izquierdo al derecho por el escote */
      var nh = s.hps.u, f = function (u, v) { return frame.fwd(u, v); };
      var a1 = f(-nh, -s.drop + s.drop * 0.65), a2 = f(-nh * 0.55, 0), m = f(0, 0), b1 = f(nh * 0.55, 0), b2 = f(nh, -s.drop + s.drop * 0.65), e = f(nh, -s.drop);
      p.bezierCurveTo(a1.x, a1.y, a2.x, a2.y, m.x, m.y);
      p.bezierCurveTo(b1.x, b1.y, b2.x, b2.y, e.x, e.y);
      p.closePath();
      return p;
    }
    /* Delante o detrás en plano. ctx en unidades del marco. */
    function drawBody(c, frame, color, noHood, cap) {
      var s = frame.shape, k = frame.pxPerCm, p = bodyPath(frame), nh = s.hps.u, xs = extentU(s);
      if (st.HOOD && frame.kind === 'front') drawHoodBehind(c, frame, color);
      if (st.COLLAR_CM) drawCollar(c, frame, color);
      fillGarment(c, frame, p, color, frame.fwd(-xs, 0).x, frame.fwd(xs, 0).x);
      c.save();
      c.clip(p);
      if (frame.kind === 'front') {
        /* por el escote se ve el interior de la espalda (más oscuro), hasta el cuello trasero */
        var inner = neckCurve(new Path2D(), frame, nh, -s.drop, 0);
        var back = frame.fwd(0, -s.drop + drop(frame.med.pecho, 'back')), b = frame.fwd(-nh, -s.drop), e = frame.fwd(nh, -s.drop);
        inner.quadraticCurveTo(back.x, back.y + (back.y - e.y), b.x, b.y);
        c.fillStyle = 'rgba(0,0,0,0.16)';
        c.fill(inner);
      }
      /* canalé del cuello: banda algo más oscura bajo el escote y su pespunte */
      c.lineCap = 'round';
      c.strokeStyle = 'rgba(0,0,0,0.07)';
      c.lineWidth = SHAPE.RIB_CM * k;
      c.stroke(neckCurve(new Path2D(), frame, nh, -s.drop + SHAPE.RIB_CM / 2, SHAPE.RIB_CM / 2));
      seam(c, k, true, color);
      c.stroke(neckCurve(new Path2D(), frame, nh, -s.drop + SHAPE.RIB_CM, SHAPE.RIB_CM));
      /* costuras: hombros y sisas (raglán: la diagonal del escote a la sisa; sin mangas: el ribete de la sisa), bajo de
         las mangas y del cuerpo */
      c.beginPath();
      [1, -1].forEach(function (sg) {
        var m = function (q) { return { u: q.u * sg, v: q.v }; };
        if (st.sleeves === 'sin') {
          var bind = st.ARMHOLE_BIND_CM;
          s.arm.forEach(function (q, i) { if (i) line(c, frame, m({ u: s.arm[i - 1].u - bind, v: s.arm[i - 1].v }), m({ u: q.u - bind, v: q.v })); });
          return;
        }
        if (st.sleeves === 'raglan') line(c, frame, m(s.rn), m(s.ap));
        else if (st.sleeves !== 'kimono') { line(c, frame, m(s.hps), m(s.sp)); line(c, frame, m(s.sp), m(s.ap)); }
        var back = { u: -s.dir.u * st.SLEEVE_STITCH_CM, v: -s.dir.v * st.SLEEVE_STITCH_CM };
        line(c, frame, m(add(s.sht, back, 1)), m(add(s.shb, back, 1)));
      });
      if (!st.WAIST_CM) line(c, frame, { u: -s.half, v: s.hemV - SHAPE.HEM_STITCH_CM }, { u: s.half, v: s.hemV - SHAPE.HEM_STITCH_CM });
      c.stroke();
      if (st.WAIST_CM) drawSweatDetails(c, frame, color);
      c.restore();
      outline(c, frame, p, color);
      if (st.HOOD && frame.kind === 'back' && !noHood) drawHoodBack(c, frame, color, cap);
    }

    /* ---------- sudaderas ---------- */
    function pathOf(frame, pts, close) {
      var p = new Path2D();
      pts.forEach(function (q, i) { var x = frame.fwd(q.u, q.v); if (i) p.lineTo(x.x, x.y); else p.moveTo(x.x, x.y); });
      if (close) p.closePath();
      return p;
    }
    function curvePts(a, c1, c2, b) { var out = []; for (var i = 0; i <= CURVE_STEPS; i++) out.push(bez(a, c1, c2, b, i / CURVE_STEPS)); return out; }
    /* Capucha vista de frente, detrás del cuerpo: su contorno sobre los hombros y el forro (más oscuro) en la abertura. */
    function drawHoodBehind(c, frame, color) {
      var s = frame.shape, P = s.half * 2, hw = st.HOOD.W * P / 2, top = -s.drop - st.HOOD.UP * P, nh = s.hps.u;
      /* incluye el escote (hasta el cruce de la capucha en el cuello delantero) para que no quede hueco */
      var low = [{ u: nh + 1, v: -s.drop * 0.25 }, { u: nh * 0.7, v: 0.6 }, { u: 0, v: 1 }];
      var outer = low.concat(low.slice(0, 2).reverse().map(mirror))
        .concat(curvePts({ u: -nh - 1, v: -s.drop + 2 }, { u: -hw * 1.05, v: top + (st.HOOD.UP * P) * 0.35 }, { u: -hw * 0.6, v: top }, { u: 0, v: top }))
        .concat(curvePts({ u: 0, v: top }, { u: hw * 0.6, v: top }, { u: hw * 1.05, v: top + (st.HOOD.UP * P) * 0.35 }, { u: nh + 1, v: -s.drop + 2 }));
      var p = pathOf(frame, outer, true);
      fillGarment(c, frame, p, color, frame.fwd(-hw, 0).x, frame.fwd(hw, 0).x);
      /* abertura de la cara: forro más oscuro que baja hasta el cruce de la capucha en el cuello delantero */
      var ih = nh * 0.92, it = top + 0.12 * st.HOOD.UP * P;
      var inner = curvePts({ u: 0, v: 0 }, { u: -ih * 1.15, v: -s.drop * 0.6 }, { u: -ih * 0.95, v: it }, { u: 0, v: it })
        .concat(curvePts({ u: 0, v: it }, { u: ih * 0.95, v: it }, { u: ih * 1.15, v: -s.drop * 0.6 }, { u: 0, v: 0 }));
      c.save();
      c.fillStyle = 'rgba(0,0,0,0.2)';
      c.fill(pathOf(frame, inner, true));
      c.restore();
      outline(c, frame, p, color);
    }
    /* Contorno de la capucha caída sobre la espalda (cm de la vista de detrás, v desde el cuello trasero). cap: la de la
       foto del producto (cal.capucha: { fondo: punta bajo el punto alto del hombro, en fracción del largo; ancho: medio
       ancho en fracción del ½ pecho }) o null (la estándar: HOOD.BACK·P bajo el cuello, ancho HOOD.W·P). dropCm: del punto
       alto del hombro al cuello trasero en ese marco (foto: 1,5 cm; por defecto, el de la plantilla). */
    function hoodOutline(med, cap, dropCm) {
      var s = shape(med, 'back'), P = s.half * 2, drop = dropCm == null ? s.drop : dropCm, top = -s.drop - st.HOOD.UP * P;
      var hw = cap && cap.ancho > 0 ? cap.ancho * P / 2 : st.HOOD.W * P / 2;
      var bot = cap && cap.fondo > 0 ? cap.fondo * med.largo - drop : st.HOOD.BACK * P;
      var side = { u: HOOD_SIDE_U * hw, v: bot - HOOD_RISE * hw }, low = [];
      for (var i = HOOD_STEPS; i >= 0; i--) low.push({ u: side.u * i / HOOD_STEPS, v: bot - HOOD_RISE * hw * Math.pow(i / HOOD_STEPS, HOOD_POW) });
      var pts = curvePts({ u: 0, v: top }, { u: hw * 0.7, v: top }, { u: hw * 1.05, v: top + 0.4 * (side.v - top) }, side).concat(low.slice(1));
      return pts.concat(pts.slice().reverse().map(mirror));
    }
    /* Silueta de la capucha en px del marco (vale también para el marco de la foto: frame.fwd la curva al cuerpo). */
    function hoodPath(frame, cap, dropCm) { return st.HOOD ? pathOf(frame, hoodOutline(frame.med, cap, dropCm), true) : null; }
    /* Lo más bajo de la capucha a la altura u (cm desde el cuello trasero), o null si no llega a esa u. */
    function hoodBottomAt(pts, u) {
      var best = null;
      for (var i = 0; i < pts.length; i++) {
        var a = pts[i], b = pts[(i + 1) % pts.length];
        if ((a.u - u) * (b.u - u) > 0 || a.u === b.u) continue;
        var v = a.v + (b.v - a.v) * (u - a.u) / (b.u - a.u);
        if (best == null || v > best) best = v;
      }
      return best;
    }
    /* Cuánto tapa la capucha bajada de una caja de diseño { x0, x1, y0, y1 } (cm de la vista de detrás), medido desde su
       borde superior: lo más que baja la capucha sobre el ancho del diseño. 0 si no lo toca. */
    function hoodCover(med, box, cap) {
      if (!st.HOOD || !(box.x1 > box.x0)) return 0;
      var pts = hoodOutline(med, cap), n = 24, out = 0;
      for (var i = 0; i <= n; i++) {
        var v = hoodBottomAt(pts, box.x0 + (box.x1 - box.x0) * i / n);
        if (v != null) out = Math.max(out, Math.min(v, box.y1) - box.y0);
      }
      return out;
    }
    /* Capucha caída sobre la espalda (vista de detrás, encima del cuerpo y, en el editor, del diseño), con la costura
       central. */
    function drawHoodBack(c, frame, color, cap) {
      var s = frame.shape, P = s.half * 2, top = -s.drop - st.HOOD.UP * P, k = frame.pxPerCm, pts = hoodOutline(frame.med, cap);
      var bot = pts[Math.floor(pts.length / 2)].v, p = pathOf(frame, pts, true);
      c.save();
      c.shadowColor = 'rgba(0,0,0,0.18)';
      c.shadowBlur = 1.2 * k;
      c.shadowOffsetY = 0.4 * k;
      c.fillStyle = color;
      c.fill(p);
      c.restore();
      c.save();
      c.clip(p);
      seam(c, k, true, color);
      c.beginPath();
      line(c, frame, { u: 0, v: top }, { u: 0, v: bot });
      c.stroke();
      c.restore();
      outline(c, frame, p, color);
    }
    /* Cuello alto (cremallera sin capucha y 1/4 de cremallera): banda sobre el escote, detrás del cuerpo. */
    function drawCollar(c, frame, color) {
      var s = frame.shape, nh = s.hps.u, h = st.COLLAR_CM;
      /* hasta el centro del escote: por delante se ve el interior del cuello */
      var p = pathOf(frame, [{ u: -nh, v: -s.drop + 1 }, { u: -nh * 0.95, v: -s.drop - h }, { u: nh * 0.95, v: -s.drop - h }, { u: nh, v: -s.drop + 1 }, { u: 0, v: 1 }], true);
      fillGarment(c, frame, p, color, frame.fwd(-nh, 0).x, frame.fwd(nh, 0).x);
      outline(c, frame, p, color);
    }
    /* Canalé de la cintura, bolsillo, cremallera y cordones (dentro del recorte del cuerpo). */
    function drawSweatDetails(c, frame, color) {
      var s = frame.shape, k = frame.pxPerCm, P = s.half * 2, wv = s.hemV - st.WAIST_CM;
      /* canalé: banda algo más oscura con su pespunte y un rayado vertical suave */
      c.fillStyle = 'rgba(0,0,0,0.06)';
      c.fill(pathOf(frame, [{ u: -s.half - 1, v: wv }, { u: s.half + 1, v: wv }, { u: s.half + 1, v: s.hemV + 1 }, { u: -s.half - 1, v: s.hemV + 1 }], true));
      seam(c, k, false, color);
      c.globalAlpha = 0.35;
      c.beginPath();
      for (var u = -s.half; u <= s.half; u += 0.6) line(c, frame, { u: u, v: wv + 0.3 }, { u: u, v: s.hemV });
      c.stroke();
      c.globalAlpha = 1;
      seam(c, k, true, color);
      c.beginPath();
      line(c, frame, { u: -s.half, v: wv }, { u: s.half, v: wv });
      c.stroke();
      if (frame.kind !== 'front') return;
      if (st.POCKET) {
        var top = pocketTop(frame.med, frame.pocketCm), tw = st.POCKET.TOP_W * P / 2, bw = st.POCKET.BOT_W * P / 2, open = 0.55;
        c.beginPath();
        if (st.POCKET.split) {
          var gap = st.ZIP_W_CM / 2 + 1;
          [1, -1].forEach(function (sg) {
            var m = function (q) { return { u: q.u * sg, v: q.v }; };
            line(c, frame, m({ u: gap, v: top }), m({ u: tw * open, v: top }));
            line(c, frame, m({ u: tw * open, v: top }), m({ u: bw, v: wv }));
          });
        } else {
          line(c, frame, { u: -tw * open, v: top }, { u: tw * open, v: top });
          [1, -1].forEach(function (sg) { line(c, frame, { u: sg * tw * open, v: top }, { u: sg * bw, v: wv }); });
        }
        c.stroke();
        c.save();
        c.strokeStyle = luma(color) < DARK_LUMA ? 'rgba(255,255,255,0.28)' : 'rgba(0,0,0,0.18)';
        c.lineWidth = 0.14 * k;
        c.setLineDash([]);
        c.beginPath();
        if (st.POCKET.split) [1, -1].forEach(function (sg) { line(c, frame, { u: sg * (st.ZIP_W_CM / 2 + 1), v: top }, { u: sg * tw * open, v: top }); });
        else line(c, frame, { u: -tw * open, v: top }, { u: tw * open, v: top });
        [1, -1].forEach(function (sg) { line(c, frame, { u: sg * tw * open, v: top }, { u: sg * bw, v: wv }); });
        c.stroke();
        c.restore();
      }
      if (st.ZIP) {
        var zEnd = st.ZIP === 'cuarto' ? zipEnd(frame.med) : s.hemV, zw = st.ZIP_W_CM / 2;
        c.save();
        c.fillStyle = luma(color) < DARK_LUMA ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.14)';
        c.fill(pathOf(frame, [{ u: -zw, v: -s.drop - (st.COLLAR_CM || 0) }, { u: zw, v: -s.drop - (st.COLLAR_CM || 0) }, { u: zw, v: zEnd }, { u: -zw, v: zEnd }], true));
        c.restore();
        seam(c, k, false, color);
        c.beginPath();
        line(c, frame, { u: 0, v: -s.drop - (st.COLLAR_CM || 0) }, { u: 0, v: zEnd });
        c.stroke();
        /* tirador */
        var tp = frame.fwd(0.6, (st.ZIP === 'cuarto' ? zEnd : 0) + 0.2);
        c.fillStyle = 'rgba(0,0,0,0.35)';
        c.fillRect(tp.x - 0.3 * k, tp.y, 0.6 * k, 2.6 * k);
      }
      if (st.HOOD) {
        /* cordones */
        c.save();
        c.strokeStyle = luma(color) < DARK_LUMA ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.25)';
        c.lineWidth = 0.35 * k;
        c.lineCap = 'round';
        c.setLineDash([]);
        c.beginPath();
        [1, -1].forEach(function (sg) { line(c, frame, { u: sg * 3.2, v: -1.2 }, { u: sg * 3.5, v: 0.18 * P }); });
        c.stroke();
        c.restore();
      }
    }
    /* Bolsillo: v del borde superior (cm desde el cuello delantero). pocketCm: distancia del bajo al borde superior
       medida en la foto (si es fiable); si no, la estándar. */
    function pocketTop(med, pocketCm) {
      var P = med.pecho, hv = hemV(med, 'front');
      return hv - (pocketCm > 0 ? pocketCm : st.WAIST_CM + st.POCKET.H * P);
    }
    function zipEnd(med) { return st.ZIP_LEN * med.pecho; }

    function sleevePath(frame) {
      var p = new Path2D(), f = function (u, v) { return frame.fwd(u, v); };
      var wt = frame.wTop / 2, wh = frame.wHem / 2, cap = frame.cap;
      if (frame.raglan) {
        /* raglán: arriba la parte del cuello, que se abre en diagonal hasta la sisa */
        var wn = frame.wNeck / 2, pts = [f(-wn, 0), f(wn, 0), f(wt, frame.vArm), f(wh, frame.L), f(-wh, frame.L), f(-wt, frame.vArm)];
        pts.forEach(function (q, i) { if (i) p.lineTo(q.x, q.y); else p.moveTo(q.x, q.y); });
        p.closePath();
        return p;
      }
      var a = f(-wt, cap), t = f(0, 0), b = f(wt, cap), c1 = f(-wt * 0.75, -cap * 0.15), c2 = f(-wt * 0.35, 0), c3 = f(wt * 0.35, 0), c4 = f(wt * 0.75, -cap * 0.15);
      p.moveTo(a.x, a.y);
      p.bezierCurveTo(c1.x, c1.y, c2.x, c2.y, t.x, t.y);
      p.bezierCurveTo(c3.x, c3.y, c4.x, c4.y, b.x, b.y);
      var hr = f(wh, frame.L), hl = f(-wh, frame.L);
      p.lineTo(hr.x, hr.y);
      p.lineTo(hl.x, hl.y);
      p.closePath();
      return p;
    }
    /* Manga extendida en plano (hombro arriba). */
    function drawSleeve(c, frame, color) {
      var k = frame.pxPerCm, p = sleevePath(frame), wh = frame.wHem / 2;
      /* puño alto (manga larga): el pespunte cruza la manga a su altura, donde es algo más ancha que el bajo */
      var ws = st.SLEEVE_STITCH_CM > SHAPE.SLEEVE_STITCH_CM ? wh + (frame.wTop / 2 - wh) * st.SLEEVE_STITCH_CM / frame.L : wh;
      fillGarment(c, frame, p, color, frame.fwd(-frame.wTop / 2, 0).x, frame.fwd(frame.wTop / 2, 0).x);
      c.save();
      c.clip(p);
      seam(c, k, true, color);
      c.beginPath();
      line(c, frame, { u: -ws, v: frame.L - st.SLEEVE_STITCH_CM }, { u: ws, v: frame.L - st.SLEEVE_STITCH_CM });
      c.stroke();
      if (st.CUFF_CM) {
        c.fillStyle = 'rgba(0,0,0,0.06)';
        c.fill(pathOf(frame, [{ u: -ws - 1, v: frame.L - st.CUFF_CM }, { u: ws + 1, v: frame.L - st.CUFF_CM }, { u: ws + 1, v: frame.L + 1 }, { u: -ws - 1, v: frame.L + 1 }], true));
        seam(c, k, false, color);
        c.globalAlpha = 0.35;
        c.beginPath();
        for (var u = -ws; u <= ws; u += 0.6) line(c, frame, { u: u, v: frame.L - st.CUFF_CM + 0.3 }, { u: u, v: frame.L });
        c.stroke();
        c.globalAlpha = 1;
      }
      c.restore();
      outline(c, frame, p, color);
      c.save();
      c.font = '600 ' + 0.75 * k + 'px sans-serif';
      c.textAlign = 'center';
      c.fillStyle = '#8C867E';
      var t = frame.fwd(0, -1.6);
      c.fillText(frame.raglan ? 'Manga extendida · cuello arriba' : 'Manga extendida · hombro arriba', t.x, t.y);
      c.restore();
    }
    /* opts.noHood: detrás, sin la capucha (el editor la dibuja después, encima del diseño, con drawHood). */
    /* opts.capucha: la de la foto del producto (cal.capucha). */
    function draw(c, frame, color, opts) {
      if (frame.kind === 'sleeve') drawSleeve(c, frame, color);
      else drawBody(c, frame, color, !!(opts && opts.noHood), (opts && opts.capucha) || null);
    }
    /* Capucha de la vista de detrás con opacidad alpha (encima del diseño en el editor). */
    function drawHood(c, frame, color, alpha, cap) {
      if (!st.HOOD || frame.kind !== 'back' || !(alpha > 0)) return;
      c.save();
      c.globalAlpha = alpha;
      drawHoodBack(c, frame, color, cap);
      c.restore();
    }

    /* Zona útil para colocar diseños (cm de la vista), con los márgenes del modelo: { chest, hem, neck, armhole } (neck:
       distancia mínima al cuello de la vista; armhole: separación de la sisa en las prendas sin mangas; v = 0 es el punto más bajo del escote delante y la nuca detrás). Mangas: null (las
       limita su impresión de 10×10). halfAt(v): medio ancho útil a la altura v donde la prenda se estrecha por arriba
       (costuras del raglán, sisas de los tirantes); el editor baja o centra el diseño para que quepa. */
    function useful(med, kind, margins, opts) {
      if (kind === 'sleeve') return null;
      var h = (med.pecho - margins.chest) / 2, out = { x0: -h, x1: h, y0: margins.neck || 0, y1: hemV(med, kind) - margins.hem };
      var s = shape(med, kind), edge = null;
      if (st.sleeves === 'sin') edge = s.arm;
      else if (st.sleeves === 'raglan') edge = [s.rn, s.ap];
      var gap = st.sleeves === 'sin' && margins.armhole != null ? margins.armhole : margins.chest / 2;
      if (edge) out.halfAt = function (v) { return Math.min(h, uAt(edge, v) - gap); };
      return st.WAIST_CM ? sweatUseful(med, kind, out, opts || {}) : out;
    }
    /* Sudaderas: por encima del canalé de la cintura y del bolsillo (detrás, desde el cuello: la capucha no limita, solo
       tapa); con 1/4 de cremallera,
       bajo su final; con cremallera completa, cada pecho a su lado (opts.split: 1 = pecho izq. del que la lleva, a la
       derecha de la imagen; -1 = pecho dcha.) sin acercarse a la cremallera. opts.pocketCm: bolsillo de la foto. */
    function sweatUseful(med, kind, out, opts) {
      var P = med.pecho, hv = hemV(med, kind);
      out.y1 = Math.min(out.y1, hv - st.WAIST_CM - RIB_MARGIN_CM);
      if (kind === 'front' && st.POCKET) out.y1 = Math.min(out.y1, pocketTop(med, opts.pocketCm) - RIB_MARGIN_CM);
      if (kind === 'front' && st.ZIP === 'cuarto') out.y0 = Math.max(out.y0, zipEnd(med) + RIB_MARGIN_CM);
      if (kind === 'front' && st.ZIP === 'completa' && opts.split) {
        var inner = st.ZIP_W_CM / 2 + st.ZIP_CLEAR_CM;
        if (opts.split > 0) out.x0 = inner; else out.x1 = -inner;
      }
      return out;
    }
    function fmt(v) { return String(Math.round(v * 10) / 10).replace('.', ','); }
    /* Cotas de la prenda (cm de la vista): { a, b, text, at, align (left/right/center del punto at, o vertical: girada
       y centrada en él), leaders }. Los valores son los de labelMed (la talla
       de referencia) aunque la silueta esté a mitad de la transición. */
    function measures(frame) {
      var m = frame.labelMed || frame.med;
      if (frame.kind === 'sleeve') {
        var x = Math.max(frame.wTop, frame.wHem) / 2 + 1.5, wh = frame.wHem / 2, yb = frame.L + 1.5;
        return [
          { a: { u: x, v: 0 }, b: { u: x, v: frame.L }, text: (frame.raglan ? 'Manga raglán ' : 'Manga ') + fmt(sleeveLen(m)) + ' cm', at: { u: x, v: frame.L * 0.4 }, align: 'right',
            leaders: [[{ u: 0, v: 0 }, { u: x, v: 0 }], [{ u: wh, v: frame.L }, { u: x, v: frame.L }]] },
          { a: { u: -wh, v: yb }, b: { u: wh, v: yb }, text: (st.SLEEVE_STITCH_CM > 4 ? 'Puño ' : 'Bajo ') + fmt(sleeveHemW(m)) + ' cm', at: { u: 0, v: yb }, align: 'center',
            leaders: [[{ u: -wh, v: frame.L }, { u: -wh, v: yb }], [{ u: wh, v: frame.L }, { u: wh, v: yb }]] }
        ];
      }
      /* manga larga: cae junto al cuerpo; la cota del largo va por fuera de la manga */
      var s = frame.shape, yc = s.ap.v + CHEST_BELOW_ARMPIT_CM, xl = -(st.SLEEVE_ANGLE_DEG > 45 && s.sht ? Math.max(s.half, s.sht.u) : s.half) - DIM_GAP_CM;
      var out = [
        { a: { u: -s.half, v: yc }, b: { u: s.half, v: yc }, text: 'Pecho ' + fmt(m.pecho) + ' cm', at: { u: s.half, v: yc }, align: 'left', leaders: [] }, /* fuera del costado: ningún diseño llega ahí */
        { a: { u: xl, v: -s.drop }, b: { u: xl, v: s.hemV }, text: 'Largo ' + fmt(m.largo) + ' cm', at: { u: xl, v: (s.ap.v + s.hemV) / 2 }, align: 'vertical',
          leaders: [[{ u: -s.hps.u, v: -s.drop }, { u: xl, v: -s.drop }], [{ u: -s.half, v: s.hemV }, { u: xl, v: s.hemV }]] }
      ];
      /* manga estimada (manga larga sin manga en la guía; corex.medidas manga_est): se dibuja, pero sin cota */
      if (!s.sht || st.sleeves === 'kimono' || m.manga_est) return out;
      var from = st.sleeves === 'raglan' ? s.hps : s.sp, dirOut = { u: s.dir.v, v: -s.dir.u }, off = 1.5;
      var sa = add(from, dirOut, off), sb = add(s.sht, dirOut, off);
      out.push({ a: sa, b: sb, text: (st.sleeves === 'raglan' ? 'Manga raglán ' : 'Manga ') + fmt(sleeveLen(m)) + ' cm', at: { u: (sa.u + sb.u) / 2, v: (sa.v + sb.v) / 2 }, align: 'center',
        leaders: [[from, sa], [s.sht, sb]] });
      return out;
    }

    var T = { key: key, SHAPE: st, shape: shape, hemV: hemV, sleeveHemW: sleeveHemW, sleeveTopW: sleeveTopW, hasSleeves: hasSleeves,
      bodyFrame: bodyFrame, sleeveFrame: sleeveFrame, draw: draw, useful: useful, measures: measures,
      /* sudaderas: alto del canalé del puño (la impresión de manga se mide desde el puño y no lo pisa) */
      cuffCm: st.CUFF_CM || 0, zoned: !!st.WAIST_CM,
      /* sudaderas con capucha: la capucha de detrás, encima del diseño (editor) o recortándolo (vista previa) */
      hasHood: !!st.HOOD, drawHood: drawHood, hoodPath: hoodPath, hoodCover: hoodCover };
    return T;
  }

  /* ---------- trazo común ---------- */
  /* Costuras: oscuras sobre tela clara, claras sobre tela oscura (si no, en negro no se ven). */
  function seam(c, k, dashed, color) {
    c.strokeStyle = luma(color) < DARK_LUMA ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.2)';
    c.lineWidth = 0.08 * k;
    c.setLineDash(dashed ? [0.35 * k, 0.25 * k] : []);
  }
  function line(c, frame, a, b) { var p = frame.fwd(a.u, a.v), q = frame.fwd(b.u, b.v); c.moveTo(p.x, p.y); c.lineTo(q.x, q.y); }
  function luma(color) {
    var m = String(color).match(/\d+/g);
    return m ? 0.299 * m[0] + 0.587 * m[1] + 0.114 * m[2] : 128;
  }
  function isLight(color) { return luma(color) > 200; }
  /* Sombra suave, color de la prenda, sombreado lateral y contorno fino. */
  function fillGarment(c, frame, p, color, x0, x1) {
    var k = frame.pxPerCm;
    c.save();
    c.shadowColor = 'rgba(0,0,0,0.2)';
    c.shadowBlur = 1.4 * k;
    c.shadowOffsetY = 0.35 * k;
    c.fillStyle = color;
    c.fill(p);
    c.restore();
    c.save();
    c.clip(p);
    var g = c.createLinearGradient(x0, 0, x1, 0);
    g.addColorStop(0, 'rgba(0,0,0,0.10)');
    g.addColorStop(0.25, 'rgba(0,0,0,0.02)');
    g.addColorStop(0.5, 'rgba(255,255,255,0.05)');
    g.addColorStop(0.75, 'rgba(0,0,0,0.02)');
    g.addColorStop(1, 'rgba(0,0,0,0.10)');
    c.fillStyle = g;
    c.fillRect(frame.view.x, frame.view.y, frame.view.w, frame.view.h);
    c.restore();
  }
  function outline(c, frame, p, color) {
    c.save();
    c.strokeStyle = isLight(color) ? 'rgba(0,0,0,0.22)' : 'rgba(0,0,0,0.12)';
    c.lineWidth = 0.06 * frame.pxPerCm;
    c.stroke(p);
    c.restore();
  }

  var TEMPLATES = {};
  Object.keys(STYLES).forEach(function (key) {
    var st = Object.assign({}, SHAPE, STYLES[key]);
    TEMPLATES[key] = make(key, st);
    if (st.SLEEVELESS) TEMPLATES[key + '/sin-mangas'] = make(key, Object.assign({}, SHAPE, st.SLEEVELESS));
  });
  /* Plantilla de un tipo. meds (opcional): medidas de las tallas; un crop top sin manga en la guía es de tirantes. */
  function template(key, meds) {
    /* combinación de la tanda 3 ("base+forma+…"): se compone la primera vez que se pide */
    if (!TEMPLATES[key] && String(key).indexOf('+') > 0) { var st = compose(key); if (st) TEMPLATES[key] = make(key, st); }
    var t = TEMPLATES[key] || null;
    if (t && TEMPLATES[key + '/sin-mangas'] && meds && meds.length && !meds.every(function (m) { return m && m.manga > 0; })) return TEMPLATES[key + '/sin-mangas'];
    return t;
  }

  /* Dibuja las cotas de la prenda en gris fino (px = unidades del marco por px CSS). Van debajo de los diseños y de las
     cotas rojas, que se dibujan después, y la barra flotante es HTML: nunca las tapan. */
  function drawMeasures(c, frame, px, font) {
    var dims = frame.tpl.measures(frame), ink = 'rgba(95,90,83,0.8)';
    c.save();
    c.strokeStyle = ink;
    c.lineWidth = 1 * px;
    c.font = '600 ' + 10.5 * px + 'px ' + font;
    c.textBaseline = 'middle';
    dims.forEach(function (d) {
      var a = frame.fwd(d.a.u, d.a.v), b = frame.fwd(d.b.u, d.b.v), len = Math.hypot(b.x - a.x, b.y - a.y) || 1;
      var nx = -(b.y - a.y) / len * 4 * px, ny = (b.x - a.x) / len * 4 * px;
      c.setLineDash([2 * px, 3 * px]);
      c.beginPath();
      (d.leaders || []).forEach(function (l) { line(c, frame, l[0], l[1]); });
      c.stroke();
      c.setLineDash([]);
      c.beginPath();
      c.moveTo(a.x, a.y); c.lineTo(b.x, b.y);
      c.moveTo(a.x - nx, a.y - ny); c.lineTo(a.x + nx, a.y + ny);
      c.moveTo(b.x - nx, b.y - ny); c.lineTo(b.x + nx, b.y + ny);
      c.stroke();
      var p = frame.fwd(d.at.u, d.at.v), w = c.measureText(d.text).width + 10 * px, h = 16 * px;
      c.save();
      c.translate(p.x, p.y);
      if (d.align === 'vertical') c.rotate(-Math.PI / 2);
      var x0 = d.align === 'left' ? 4 * px : d.align === 'right' ? -4 * px - w : -w / 2;
      c.fillStyle = 'rgba(255,255,255,0.92)';
      c.beginPath();
      if (c.roundRect) c.roundRect(x0, -h / 2, w, h, 4 * px); else c.rect(x0, -h / 2, w, h);
      c.fill();
      c.fillStyle = '#5F5A53';
      c.textAlign = 'left';
      c.fillText(d.text, x0 + 5 * px, 0.5 * px);
      c.restore();
    });
    c.restore();
  }

  var api = { TEMPLATES: Object.keys(TEMPLATES), template: template, drawMeasures: drawMeasures };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else global.CorexTextilFlat = api;
})(this);
